"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelayedEntry = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var DelayedEntry = (function (_super) {
    __extends(DelayedEntry, _super);
    function DelayedEntry() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.DELAYED_ENTRY,
            cost: 0,
            metadata: {
                cardNumber: 'L308',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('Play as your first and only action this turn.', function (eb) {
                        eb.text('1').startAction;
                    }).br;
                    b.effect('On your next turn, take three actions.', function (eb) {
                        eb.text('3').startAction;
                    }).br;
                }),
            },
        }) || this;
    }
    DelayedEntry.prototype.canPlay = function (player) {
        return _super.prototype.canPlay.call(this, player) && (player.actionsTakenThisRound === 0 || player.allOtherPlayersHavePassed());
    };
    DelayedEntry.prototype.play = function (player) {
        player.actionsTakenThisRound = 10;
        player.maxActionsThisRound = 3;
        return undefined;
    };
    return DelayedEntry;
}(Card_1.Card));
exports.DelayedEntry = DelayedEntry;
//# sourceMappingURL=DelayedEntry.js.map